import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

export const renderOverquotaBanner = (data) => openPopupHelper({ popupName: popupNames.OVERQUOTA_BANNER, data });
